import { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { AnalisaBarangJadiRABApi } from 'api';

export const DropdownAnalisaBarangJadiContext = createContext();

export const DropdownAnalisaBarangJadiContextProvider = ({ children }) => {
  const [triggerFetch, setTriggerFetch] = useState(false);
  const [dropdown, setDropdown] = useState({
    deskripsi: [],
    part_kayu: [],
    tipe_sisi: [],
    tipe_finishing: [],
    spek_kayu: [],
    spek_plywood: [],
    tipe_produksi: [],
    bentuk: [],
    ukuran: [],
  });

  const [selectData, setSelectData] = useState({
    tpfs: [],
    tplc: [],
    tpmp: [],
    tpbop: [],
    fnbp: [],
    fnsc: [],
    fnlc: [],
  });

  const [loading, setLoading] = useState(false);

  const getDropdown = () => {
    setLoading(true);

    axios
      .all([
        AnalisaBarangJadiRABApi.getDropdownDeskripsi(),
        AnalisaBarangJadiRABApi.getDropdownPartKayu(),
        AnalisaBarangJadiRABApi.getDropdownTipeSisi(),
        AnalisaBarangJadiRABApi.getDropdownTipeFinishing(),
        AnalisaBarangJadiRABApi.getDropdownSpekKayu(),
        AnalisaBarangJadiRABApi.getDropdownSpekPlywood(),
        AnalisaBarangJadiRABApi.getDropdownTipeProduksi(),
        AnalisaBarangJadiRABApi.getDropdownBentuk(),
        AnalisaBarangJadiRABApi.getDropdownUkuran(),

        AnalisaBarangJadiRABApi.getDropdownTipeBarangJadi({ tipe: 'fs' }),
        AnalisaBarangJadiRABApi.getDropdownTipeBarangJadi({ tipe: 'lc' }),
        AnalisaBarangJadiRABApi.getDropdownTipeBarangJadi({ tipe: 'mp' }),
        AnalisaBarangJadiRABApi.getDropdownTipeBarangJadi({ tipe: 'bop' }),
        AnalisaBarangJadiRABApi.getDropdownFinishingBarangJadi({ tipe: 'bp' }),
        AnalisaBarangJadiRABApi.getDropdownFinishingBarangJadi({ tipe: 'sc' }),
        AnalisaBarangJadiRABApi.getDropdownFinishingBarangJadi({ tipe: 'lc' }),
      ])
      .then(
        axios.spread(
          (
            resDeskripsi,
            resPartKayu,
            resTipeSisi,
            resTipeFinishing,
            resSpekKayu,
            resSpekPlywood,
            resTipeProduksi,
            resBentuk,
            resUkuran,
            resTpfs,
            resTplc,
            resTpmp,
            resTpbop,
            resFnbp,
            resFnsc,
            resFnlc
          ) => {
            const deskripsi = resDeskripsi.data.data ?? [];
            const part_kayu = resPartKayu.data.data ?? [];
            const tipe_sisi = resTipeSisi.data.data ?? [];
            const tipe_finishing = resTipeFinishing.data.data ?? [];
            const spek_kayu = resSpekKayu.data.data ?? [];
            const spek_plywood = resSpekPlywood.data.data ?? [];
            const tipe_produksi = resTipeProduksi.data.data ?? [];
            const bentuk = resBentuk.data.data ?? [];
            const ukuran = resUkuran.data.data ?? [];

            const tpfs = resTpfs.data.data ?? [];
            const tpmp = resTpmp.data.data ?? [];
            const tplc = resTplc.data.data ?? [];
            const tpbop = resTpbop.data.data ?? [];
            const fnbp = resFnbp.data.data ?? [];
            const fnsc = resFnsc.data.data ?? [];
            const fnlc = resFnlc.data.data ?? [];

            setDropdown({
              deskripsi,
              part_kayu,
              tipe_sisi,
              tipe_finishing,
              spek_kayu,
              spek_plywood,
              tipe_produksi,
              bentuk,
              ukuran,
            });

            setSelectData({
              tpfs,
              tpmp,
              tplc,
              tpbop,
              fnbp,
              fnsc,
              fnlc,
            });
          }
        )
      )
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (triggerFetch) {
      getDropdown();
    }

    return () => {
      setDropdown({
        deskripsi: [],
        part_kayu: [],
        tipe_sisi: [],
        tipe_finishing: [],
        spek_kayu: [],
        spek_plywood: [],
        tipe_produksi: [],
        bentuk: [],
        ukuran: [],
      });

      setSelectData({
        tpfs: [],
        tplc: [],
        tpmp: [],
        tpbop: [],
        fnbp: [],
        fnsc: [],
        fnlc: [],
      });

      setLoading(false);
    };
  }, [triggerFetch]);

  return (
    <DropdownAnalisaBarangJadiContext.Provider
      value={{
        dropdown,
        setDropdown,
        loading,
        setLoading,
        selectData,
        setTriggerFetch,
      }}
    >
      {children}
    </DropdownAnalisaBarangJadiContext.Provider>
  );
};
